<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <span class="bg"></span>
        <v-col align-self="start" style="z-index: 0" cols="12" md="6">
          <a
            target="_blank"
            :href="loginParams.companylogo.href"
            v-if="loginParams.companylogo.show"
          >
            <img
              :src="loginParams.companylogo.src"
              :alt="loginParams.companylogo.title"
              width="200"
              class="ml-8 mt-6"
              style="position-absoulte"
            />
          </a>
          <v-col cols="12" md="8" v-if="loginParams.welcomeMessage.show">
            <h1
              class="font-weight-regular ml-5 mt-12"
              v-html="
                loginParams.welcomeMessage.customTitle || $t('WelcomeMessage')
              "
            ></h1>
            <h4
              class="font-weight-light ml-5 my-6"
              v-html="
                loginParams.welcomeMessage.customText ||
                $t('DocSeriesProductsOffer')
              "
            ></h4>
          </v-col>
          <v-row class="my-12" v-if="loginParams.otherProducts.showProducts">
            <v-col
              cols="12"
              md="4"
              v-for="(product, index) in loginParams.otherProducts.products"
              :key="index"
            >
              <a target="_blank" :href="product.href">
                <img
                  :src="product.src"
                  :alt="product.title"
                  class="ml-8"
                  width="200"
                  style="position-absoulte"
                />
              </a>
            </v-col>
          </v-row>
          <v-row
            justify="center"
            v-if="loginParams.otherProducts.linkButton.show"
          >
            <v-btn
              target="_blank"
              :href="loginParams.otherProducts.linkButton.href"
              class="mt-4"
              outlined
              color="white"
            >
              {{
                loginParams.otherProducts.linkButton.customText ||
                $t("ViewProducts")
              }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row align="start" justify="center">
            <v-btn
              v-for="(link, index) in loginParams.otherLinks"
              :key="index"
              target="_blank"
              :text="link.text && true"
              :icon="link.icon && true"
              :href="link.href"
              :color="link.color || '#4370b2'"
              ><h3 v-if="link.text">{{ $t(link.text) }}</h3>
              <v-icon v-if="link.icon" large>{{ link.icon }}</v-icon></v-btn
            >
          </v-row>
          <v-layout align-center justify-center>
            <v-flex xs12 sm10 md8 lg8>
              <v-card shaped class="elevation-1 py-10 px-3">
                <v-card-text>
                  <div
                    class="layout column align-center"
                    v-if="loginParams.productlogo.show"
                  >
                    <img
                      :src="loginParams.productlogo.src"
                      :alt="loginParams.productlogo.title"
                      style="max-width: 200px"
                    />
                    <h2 class="flex my-4 primary--text">{{ $t("SignIn") }}</h2>
                  </div>
                  <v-form @submit.prevent="login" id="check-login-form">
                    <v-text-field
                      append-icon="mdi-account"
                      name="login"
                      :label="$t('Login')"
                      type="text"
                      v-model="model.username"
                    ></v-text-field>
                    <v-text-field
                      name="password"
                      :label="$t('Password')"
                      id="password"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                      :type="showPassword ? 'text' : 'password'"
                      v-model="model.password"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    type="submit"
                    form="check-login-form"
                    block
                    color="primary"
                    @click="login"
                    :loading="loading"
                    :height="40"
                    >{{ $t("SignIn") }}</v-btn
                  >
                </v-card-actions>
                <div v-if="loginParams.saml.show">
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn
                      outlined
                      block
                      color="primary"
                      @click="samlLogin"
                      :loading="loading"
                      :height="40"
                    >
                      <img
                        :src="loginParams.saml.iconSrc"
                        :alt="this.$t('Saml Login')"
                        style="object-fit: cover; max-height: 15px"
                        class="mr-9"
                      />
                      {{
                        loginParams.saml.customText ||
                        $t("SignInWith") + " SAML"
                      }}
                    </v-btn>
                  </v-card-actions>
                </div>

                <div
                  v-if="loginParams.entraId && loginParams.entraId.show"
                >
                  <v-card-actions>
                    <v-btn
                      outlined
                      block
                      color="primary" 
                      @click="signInWithEntraid"
                      :loading="loading"
                      :height="40"
                    >
                      <img
                        :src="loginParams.entraId.iconSrc"
                        :alt="this.$t('Entra ID')"
                        style="object-fit: cover; max-height: 28px"
                        class="mr-6"
                      />
                      {{
                        loginParams.entraId.customText ||
                        $t("SignInWith") + " Entra ID"
                      }}
                    </v-btn>
                  </v-card-actions>
                </div>

                <v-layout row justify-center align-center class="pt-5">
                  <a class="secondary--text" href="#" @click="recover">{{
                    $t("LoginProblems")
                  }}</a>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-col>
      </v-container>
    </v-content>
    <app-core-footer />
    <v-hover v-slot="{ hover }">
      <v-snackbar
        :elevation="hover ? 16 : 2"
        :timeout="hover ? -1 : 3000"
        top
        center
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn dark v-bind="attrs" @click.native="snackbar.show = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-hover>
    <RecoverModal :ref="recoverModalKey" />
    <TwoFactorAuthenticationEnrollModal
      :ref="twoFactorAuthenticationEnrollModalKey"
      @on-two-factor-authentication-enroll="onTwoFactorAuthenticationEnroll"
    />
  </v-app>
</template>
<script>
import RecoverModal from "@/components/login/RecoverModal.vue";
import TwoFactorAuthenticationEnrollModal from "@/components/login/TwoFactorAuthenticationEnrollModal.vue";
import UserService from "@/services/UserService";
import EntraIdService from "@/services/EntraIdService";
import { mapGetters } from "vuex";

export default {
  components: {
    AppCoreFooter: () => import("../components/core/Footer"),
    RecoverModal,
    TwoFactorAuthenticationEnrollModal,
  },
  created() {
    if (
      this.$route.params.user_id != null &&
      this.$route.params.device_id != null
    ) {
      UserService.restoreDevice(
        this.$route.params.user_id,
        this.$route.params.device_id
      );
    }
  },
  computed: {
    recoverModalInstance() {
      return this.$refs[this.recoverModalKey];
    },
    twoFactorAuthenticationEnrollModalInstance() {
      return this.$refs[this.twoFactorAuthenticationEnrollModalKey];
    },
    ...mapGetters({
      loginParams: "account/loginParams",
    }),
  },
  data: () => ({
    showPassword: false,
    enableSSO: false,
    loading: false,
    apiUrl: "",
    recoverModalKey: "modalRecover",
    twoFactorAuthenticationEnrollModalKey: "modalTwoFactorAuthenticationEnroll",
    model: {
      username: "",
      password: "",
    },
    snackbar: {
      show: false,
      text: "",
      color: "",
    },
  }),
  methods: {
    login(e) {
      if (e) {
        e.preventDefault();
      }
      this.loading = true;
      this.$store
        .dispatch("account/login", {
          username: this.model.username,
          password: this.model.password,
        })
        .then((resp) => {
          this.loading = false;
          window.getApp.$emit("APP_LOGIN_SUCCESS");
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.error &&
            err.response.data.error.includes("FuturaeActivationQRCodeURL")
          ) {
            this.twoFactorAuthenticationEnroll(
              err.response.data.error.replace(
                "FuturaeActivationQRCodeURL: ",
                ""
              )
            );
          } else {
            this.snackbar.text =
              err.response != null
                ? err.response.data.error_description
                : "Error";
            this.snackbar.show = true;
            this.snackbar.color = "red";
          }
          this.loading = false;
        });
    },
    recover() {
      this.recoverModalInstance.new();
    },
    twoFactorAuthenticationEnroll(url) {
      this.twoFactorAuthenticationEnrollModalInstance.new(url);
    },
    onTwoFactorAuthenticationEnroll() {
      if (this.model.username != "" && this.model.password != "") this.login();
    },
    identityProviderLogin(sessionRequest) {
      this.loading = true;
      sessionRequest.then((identityProviderRequestResponse) => {
        window.open(identityProviderRequestResponse.RedirectURL, "_blank");
        this.$store
          .dispatch("account/login", {
            identity_provider_session_id:
              identityProviderRequestResponse.SessionID,
          })
          .then((resp) => {
            this.loading = false;
            window.getApp.$emit("APP_LOGIN_SUCCESS");
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.error &&
              err.response.data.error.includes("FuturaeActivationQRCodeURL")
            ) {
              this.twoFactorAuthenticationEnroll(
                err.response.data.error.replace(
                  "FuturaeActivationQRCodeURL: ",
                  ""
                )
              );
            } else {
              this.snackbar.text =
                err.response != null
                  ? err.response.data.error_description
                  : "Error";
              this.snackbar.show = true;
              this.snackbar.color = "red";
            }
            this.loading = false;
          });
      });
    },
    signInWithEntraid() {
      const sessionRequest = EntraIdService.EntraIdRequest();
      this.identityProviderLogin(sessionRequest);
    },
    samlLogin() {
      const sessionRequest = UserService.samlRequest();
      this.identityProviderLogin(sessionRequest);
    },
  },
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url("/static/login-background.png") no-repeat center center;
  background-size: cover;
  transform: scale(1.1);
}
</style>
